export const isNumber = (value) => {
  return /^\d+$/.test(value);
};
